<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import DatePicker from 'vue-datepicker-next';
import ComboBox from 'dashboard/components-next/combobox/ComboBox.vue';
import Input from 'dashboard/components-next/input/Input.vue';

defineProps({
  status: {
    type: String,
    default: '',
  },
  since: {
    type: String,
    default: '',
  },
  until: {
    type: String,
    default: '',
  },
  search: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['filterChange']);

const { t } = useI18n();

const STATUS_KEYS = [
  'pending',
  'sent',
  'delivered',
  'read',
  'replied',
  'failed',
];

const statusOptions = computed(() => [
  { value: '', label: t('CAMPAIGN.ANALYTICS.FILTERS.STATUS_ALL') },
  ...STATUS_KEYS.map(key => ({
    value: key,
    label: t(`CAMPAIGN.ANALYTICS.STATUS.${key.toUpperCase()}`),
  })),
]);
</script>

<template>
  <div class="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
    <div class="flex flex-col gap-1.5">
      <span class="text-sm font-medium text-n-slate-12">
        {{ t('CAMPAIGN.ANALYTICS.FILTERS.STATUS_LABEL') }}
      </span>
      <ComboBox
        :model-value="status"
        :options="statusOptions"
        :placeholder="t('CAMPAIGN.ANALYTICS.FILTERS.STATUS_ALL')"
        @update:model-value="emit('filterChange', { status: $event })"
      />
    </div>
    <div class="flex flex-col gap-1.5">
      <span class="text-sm font-medium text-n-slate-12">
        {{ t('CAMPAIGN.ANALYTICS.FILTERS.SINCE') }}
      </span>
      <div class="date-picker no-margin">
        <DatePicker
          :value="since"
          value-type="YYYY-MM-DD"
          format="DD/MM/YYYY"
          :editable="false"
          placeholder="dd/mm/aaaa"
          @change="emit('filterChange', { since: $event || '' })"
        />
      </div>
    </div>
    <div class="flex flex-col gap-1.5">
      <span class="text-sm font-medium text-n-slate-12">
        {{ t('CAMPAIGN.ANALYTICS.FILTERS.UNTIL') }}
      </span>
      <div class="date-picker no-margin">
        <DatePicker
          :value="until"
          value-type="YYYY-MM-DD"
          format="DD/MM/YYYY"
          :editable="false"
          placeholder="dd/mm/aaaa"
          @change="emit('filterChange', { until: $event || '' })"
        />
      </div>
    </div>
    <div class="flex flex-col gap-1.5">
      <span class="text-sm font-medium text-n-slate-12">
        {{ t('CAMPAIGN.ANALYTICS.FILTERS.SEARCH') }}
      </span>
      <Input
        :model-value="search"
        :placeholder="t('CAMPAIGN.ANALYTICS.FILTERS.SEARCH_PLACEHOLDER')"
        @update:model-value="emit('filterChange', { search: $event })"
      />
    </div>
  </div>
</template>
